"use strict";
var TemplateView = require('bunsen/views/TemplateView');
var extendCompose = require('bunsen/libraries/extendCompose');
var $ = require('dibs-jquery-shim');
var uiPosition = require('bunsen/helpers/ui-position');
var transitionEndEvent = require('bunsen/libraries/whichTransitionEndEvent');
var bunsen = require('bunsen/libraries/bunsen');
var doc = require('bunsen/helpers/windowCheck').document;
module.exports = extendCompose.call(TemplateView, {
    initialize__: function (options) {
        this._width = options.width;
        this._disableCentering = options.disableCentering;
    },
    animated: false,
    getMainElement() {
        return this.el;
    },
    isCenteringDisabled() {
        return this._disableCentering;
    },
    show() {
        var $mainEl;
        if (this._width) {
            this.getMainElement().style.width = this._width;
        }
        this.$el.appendTo(document.body);
        $mainEl = $(this.getMainElement());
        $mainEl.off(transitionEndEvent + ".bunsen-tooltip");
        this.center();
        this.$el.removeClass('pre-animation');
        this.trigger('show');
        return this;
    },
    hide(eventData) {
        var $mainEl = $(this.getMainElement());
        this.$el.addClass('pre-animation'); // starts css animation
        if (doc && doc.hidden) {
            // if the tab isn't open, don't worry about any animations,
            // just close the darn modal
            this.$el.detach();
        } else if (transitionEndEvent && this.animated) {
            $mainEl.off(transitionEndEvent + ".bunsen-tooltip");
            $mainEl.one(transitionEndEvent + ".bunsen-tooltip", bunsen.gandalf($.proxy(this.$el, 'detach')));
        } else {
            this.$el.detach();
        }
        this.trigger('hide', eventData);
        return this;
    },
    center() {
        if (this._disableCentering) {
            return;
        }
        var $mainEl = $(this.getMainElement());
        uiPosition.positionElement($mainEl.get(0), this.position);
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/components/Floater/Floater-view.es.js